import * as React from 'react';
export const firstnationalSvg = React.forwardRef(function firstnationalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0A944F',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M12.22 14.76h1.8v8.9s-5.7-1.42-5.7-7.6 5.76-7.66 7.44-7.66a7.62 7.62 0 0 1 7.45 7.23c.6 6.12-4.4 7.54-4.4 7.54v3.58s7.7-1.98 7.7-10.44c0-6.3-4.38-11.12-10.81-11.12-6.49 0-10.51 5.31-10.51 10.93 0 5.63 4.14 10.94 10.39 10.94 1.38 0 1.62-.13 1.62-.13V10h-2.16s-.3 1.32-1.02 1.75c-.72.55-1.8.74-1.8.74v2.28z',
      }),
    ),
  );
});
firstnationalSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var firstnational = {
  category: 'brand',
  colorable: false,
  name: 'firstnational',
  svg: firstnationalSvg,
};
